import { render, staticRenderFns } from "./AddDestination.vue?vue&type=template&id=6dd5be3c"
import script from "./AddDestination.vue?vue&type=script&lang=js"
export * from "./AddDestination.vue?vue&type=script&lang=js"
import style0 from "./AddDestination.vue?vue&type=style&index=0&id=6dd5be3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports